

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/DashboardLayout.css";

const DashboardLayout = ({ children, currentSection = "my-events" }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  // Use the same logged-in user saved by UserDashboard.js
  const getCurrentUser = () => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  };

  const currentUser = getCurrentUser();

  const getInitials = (name = "") => {
    const parts = name.trim().split(/\s+/).filter(Boolean);

    if (!parts.length) return "U";

    return parts.length === 1
      ? parts[0][0].toUpperCase()
      : `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  };

  const navItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: "fa-tachometer-alt",
      path: "/dashboard#dashboard",
    },
    {
      key: "my-events",
      label: "My Events",
      icon: "fa-calendar-check",
      path: "/dashboard#my-events",
    },
    {
      key: "attending",
      label: "Attending",
      icon: "fa-ticket-alt",
      path: "/dashboard#attending",
    },
    {
      key: "speaking",
      label: "Speaking",
      icon: "fa-microphone",
      path: "/dashboard#speaking",
    },
    {
      key: "notifications",
      label: "Notifications",
      icon: "fa-bell",
      path: "/dashboard#notifications",
    },
    {
      key: "settings",
      label: "Settings",
      icon: "fa-cog",
      path: "/dashboard#settings",
    },
  ];

  const renderNavItems = (showLabels) =>
    navItems.map((item) => (
      <button
        key={item.key}
        type="button"
        className={`dashboard-nav-item ${
          currentSection === item.key
            ? "dashboard-nav-item-active"
            : ""
        }`}
        title={!showLabels ? item.label : undefined}
        aria-label={item.label}
        onClick={() => navigate(item.path)}
      >
        <i className={`fas ${item.icon}`} aria-hidden="true" />
        {showLabels && <span>{item.label}</span>}
      </button>
    ));

  return (
    <div
      className={`management-dashboard-layout ${
        isExpanded ? "sidebar-is-expanded" : "sidebar-is-collapsed"
      }`}
    >
      {/* Fixed sidebar */}
      <aside
        className={`dashboard-sidebar ${
          isExpanded
            ? "sidebar-desktop-active"
            : "sidebar-mobile-active"
        }`}
      >
        <button
          type="button"
          className="dashboard-hamburger"
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
          aria-expanded={isExpanded}
        >
          <i
            className={`fas ${isExpanded ? "fa-times" : "fa-bars"}`}
            aria-hidden="true"
          />
        </button>

        {!isExpanded ? (
          /* Collapsed sidebar: avatar and icons */
          <div className="nav-mobile-view">
            <div className="dashboard-user-avatar">
              {getInitials(currentUser.name || currentUser.full_name)}
            </div>

            <nav className="dashboard-nav-menu" aria-label="Dashboard navigation">
              {renderNavItems(false)}
            </nav>
          </div>
        ) : (
          /* Expanded sidebar: user profile and labels */
          <div className="nav-desktop-view">
            <div className="dashboard-user-profile">
              <div className="dashboard-user-avatar">
                {getInitials(currentUser.name || currentUser.full_name)}
              </div>

              <div className="dashboard-user-name">
                {currentUser.name ||
                  currentUser.full_name ||
                  "User"}
              </div>

              <div className="dashboard-user-role">
                Organizer &amp; Speaker
              </div>
            </div>

            <nav className="dashboard-nav-menu" aria-label="Dashboard navigation">
              {renderNavItems(true)}
            </nav>
          </div>
        )}
      </aside>

      {/* Existing page content */}
      <main className="management-dashboard-main">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;


